module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "de01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('i', [_vm._v("I dedicate this book to my grandniece Aurora Ahern Carlsen,"), _c('br'), _vm._v(" whose gift of light opens my heart.")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("First Sentient Publications edition 2009")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("Copyright © 2009 by Adrianne Ahern, PhD")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("All rights reserved. This book, or parts thereof, may not be reproduced in any form without permission, except in the case of brief quotations embodied in critical articles and reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("A paperback original")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("Cover design by Blair O’Neil")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("Cover photo by Blair O’Neil")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("Book design by Timm Bryson")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("Ahern, Adrianne, 1960–")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("Back in charge : A guide to harnessing the magic of your brain to create the life you’ll love / Adrianne Ahern.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("ISBN 978-1-59181-190-9")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("1. Mind and body. 2. Self-perception. 3. Self-actualization (Psychology)")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("BF161.A34 2009")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("158.1--dc22")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("2009000762")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt2"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_vm._v("SENTIENT PUBLICATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("A Limited Liability Company")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("1113 Spruce Street")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_vm._v("Boulder, CO 80302")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sentientpublications.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sentientpublications.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2710f8b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 66
// module chunks = 0